export default {
  APP_ID: 'testovanie',
  DEFAULT_CONTENT_DIVIDER: 'default',
};
